module.exports = __webpack_public_path__ + "img/kv.3195c32.webp";